import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from 'src/app/core/services/environment/environment.service';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';
import { GoogleReviewResponse } from 'src/app/home/models/review.interface';
import { environment } from 'src/environments/environment';
import { Home } from '../models/home.model';

@Injectable({
  providedIn: 'root'
})
export class HomeApiService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);


  baseUrl: string = environment.baseUrl;

  constructor() {
    // URL will be accessed via signal when needed
  }

  loadHomePage(): Observable<Home> {
    const environment = this.environmentService.environment();
    if (!environment?.url) {
      throw new Error('Environment URL not available');
    }
    return this.http.get<Home>(`${environment.url}`);
  }

  getGoogleReviews(): Observable<GoogleReviewResponse> {
    const salesChannelId = this.storeConfigurationRepositoryService.salesChannelId();

    if (!salesChannelId) {
      throw new Error('Sales Channel ID not available');
    }

    const url = `${this.baseUrl}/consumer/sales_channels/${salesChannelId}/google_reviews`;
    return this.http.get<GoogleReviewResponse>(url);
  }

}
